import { SpindlLogoCombinedProps } from './types';

const usePresenter = (props: SpindlLogoCombinedProps): SpindlLogoCombinedProps => {
  return props;
};

export default usePresenter;
